import { success, failure, request } from 'app/actions';
import * as actions from './simulatedActions';
import * as helpers from './simulatedHelpers';

const initialState = {
  evaluations: [],
  evaluation: null,
  evaluationSteps: [],
  schoolOptions: [],
  evaluationLevel: null,
  years: [],
  applications: [],
  status: [],
  isLoading: false,
  hasError: false,
  error: '',
  forbidden: undefined,
  groups: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_GROUPS):
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case success(actions.GET_GROUPS):
      return { ...state, groups: action.payload.content, isLoading: false };
    case failure(actions.GET_GROUPS):
      return {
        ...state,
        isLoading: false,
        hasError: true,
        error: action.error.message,
      };
    case request(actions.GET_EVALUATION_STEPS):
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case request(actions.GET_EVALUATIONS):
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case success(actions.GET_EVALUATIONS):
      return {
        ...state,
        evaluations: helpers.getEvaluations(action.payload.content),
        years: helpers.getYears(action.payload.content),
        status: helpers.getStatus(action.payload.content),
        applications: helpers.getApplications(action.payload.content),
        isLoading: false,
      };
    case request(actions.GET_EVALUATION_INFORMATION):
      return { ...state, forbidden: initialState.forbidden, isLoading: true };
    case success(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        evaluation: helpers.getEvaluationInformation(action.payload.content),
        schoolOptions: helpers.getSchoolOptions(action.payload.content),
        evaluationLevel: action.payload.content.evaluation.idEvaluationCataloging,
        // isLoading: false,
        forbidden: false,
      };
    case failure(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        // isLoading: false,
        hasError: true,
        error: action.error.message,
        forbidden: true,
      };
    case success(actions.GET_EVALUATION_STEPS):
      return {
        ...state,
        evaluationSteps: action.payload.content,
        // isLoading: false,
      };
    case failure(actions.GET_EVALUATION_STEPS):
      return {
        ...state,
        evaluationSteps: [],
        // isLoading: false,
        hasError: true,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default reducer;
